var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFilter = function SvgIconFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: 2,
    transform: "translate(1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M0 4.412h1.647m7.177 0h19.411M0 15h10.588m7.059 0h10.588M0 25.588h19.412m7.059 0h1.764"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.294,
    cy: 4.412,
    r: 3.412
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.941,
    cy: 25.588,
    r: 3.412
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.118,
    cy: 15,
    r: 3.412
  }))));
};
export { SvgIconFilter as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMSAzMCI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjUpIj48cGF0aCBzdHJva2UtbGluZWNhcD0icm91bmQiIGQ9Ik0wIDQuNDEyaDEuNjQ3TTguODI0IDQuNDEyaDE5LjQxMU0wIDE1aDEwLjU4OE0xNy42NDcgMTVoMTAuNTg4TTAgMjUuNTg4aDE5LjQxMk0yNi40NzEgMjUuNTg4aDEuNzY0Ii8+PGNpcmNsZSBjeD0iNS4yOTQiIGN5PSI0LjQxMiIgcj0iMy40MTIiLz48Y2lyY2xlIGN4PSIyMi45NDEiIGN5PSIyNS41ODgiIHI9IjMuNDEyIi8+PGNpcmNsZSBjeD0iMTQuMTE4IiBjeT0iMTUiIHI9IjMuNDEyIi8+PC9nPjwvc3ZnPg==";